import { ActionIcon, Box, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus as AddIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { TechnologicalTransfer } from '@/module/Author/TechnologicalTransfer';
import { TechnologicalTransferCard } from '@/module/Author/TechnologicalTransfer/components/Card/TechnologicalTransferCard';

import { NoContentPlaceholder } from '@/core/components';

import { useFilterAvailable } from './hooks/useFilterAvailable';

interface CriteriaTechnologicalTransferSelectAddModalProps {
  available: TechnologicalTransfer[];
  selected: TechnologicalTransfer[];

  close: () => void;
  onAdd: (technologicalTransfer: TechnologicalTransfer) => void;
}

export function CriteriaTechnologicalTransferSelectAddModal({
  available,
  selected,
  close,
  onAdd,
}: CriteriaTechnologicalTransferSelectAddModalProps) {
  const { searchProps, options } = useFilterAvailable({ available, selected });
  const { t } = useTranslation();

  return (
    <Modal
      size="70vw"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <Box p="sm">
        <Text
          fw="500"
          size="lg"
        >
          Proiecte
        </Text>
        <TextInput
          label="caută după titlu și autori"
          {...searchProps}
        />
      </Box>
      <Box
        mah="70vh"
        style={{ overflow: 'scroll' }}
      >
        {options.length === 0 && <NoContentPlaceholder title="Nu exista date" />}
        <Stack p="sm">
          {options.map(technologicalTransfer => (
            <Flex
              align="center"
              key={technologicalTransfer.id}
            >
              <ActionIcon
                mr="5px"
                onClick={() => onAdd(technologicalTransfer)}
                variant="filled"
                aria-label={t('button.add')}
              >
                <AddIcon
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
              <TechnologicalTransferCard
                technologicalTransfer={technologicalTransfer}
                onClick={() => window.open(`/author/technological-transfer/${technologicalTransfer.id}`)}
              />
            </Flex>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
